export default "__VITE_ASSET__DLodA36p__"